import React from "react";
import "./profile.css";
import Navbar from "../../components/navbar/Navbar";
import parse from "html-react-parser";
import logo from "../../images/white-logo.png";
import { BiPencil } from "react-icons/bi";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import profile from "../../images/profile.png";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Rightside from "../../components/rightside/Rightside";
import Footer from "../../components/footer/Footer";
import FooterMob from "../../components/footer/FooterMob";
import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl } from "../../context/BaseUrl";
import MobNav from "../../components/Mobnav/MobNav";

const Profile = () => {
  const navigate = useNavigate();
  const [Data, setData] = useState(false);

  const val = localStorage.getItem("user");
  const user = JSON.parse(val);
  if (user) {
    var id = user.user._id;
  }

  const fetchData = async () => {
    const response = await fetch(`${baseUrl}/user/getuserdet/${id}`);

    const result = await response.json();
    console.log("response_________", result);
    if (result.code == 500) {
      toast.error(response.msg);
      setTimeout(() => {
        navigate(`/user-from/${id}`);
      }, 500);

      return;
    }

    setData(() => result);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    Data && (
      <>
        <div className="home-background">
          {/* <div className="logged"> */}
          <Navbar logoimg={logo} />
          {/* </div> */}
        </div>
          <MobNav />
        {Data.map((item) => (
          <div className="profile-page">
            <div className="row">
              <div className="col-lg-8 col-md-7 col-sm-12 col-xs-12">
                <div className="profile-bg pc d-none d-md-flex">
                  <img src={item.photo} alt="profile" />
                  <div className="text">
                    <h4>{item.username}</h4>
                    <p>{item.number}</p>
                    <p>{item.email}</p>
                    <p>{item.city}</p>
                  </div>
                  <span>
                    <BiPencil />
                  </span>
                </div>
                <div className="profile-bg mobile d-flex d-md-none">
                  <img src={item.photo} alt="profile" />
                  <div className="text">
                    <h4 className="pb-0 mb-2">{item.username}</h4>
                    <p className="mb-1">{item.number}</p>
                    <p className="mb-1">{item.email}</p>
                    <p className="mb-1">{item.address}</p>

                  </div>
                  <span className="pro-editing">
                    <BiPencil />
                  </span>
                </div>

                <Tabs
                  defaultActiveKey="inform"
                  transition={false}
                  id="noanim-tab-example"
                  className="mb-3"
                >
                  <Tab eventKey="inform" title="Personal Information">
                    <Form>
                      <span className="editing">
                        <BiPencil />
                      </span>
                      <Form.Group
                        as={Row}
                        className="value mb-1"
                        controlId="name"
                      >
                        <Form.Label column lg={2} md={3} xs={4}>
                          Name
                        </Form.Label>
                        <Col md={6} xs={8}>
                          {item.username}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="value mb-1"
                        controlId="email"
                      >
                        <Form.Label column lg={2} md={3} xs={4}>
                          Email
                        </Form.Label>
                        <Col md={6} xs={8}>
                          {item.email}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="value mb-1"
                        controlId="phone"
                      >
                        <Form.Label column lg={2} md={3} xs={4}>
                          Phone
                        </Form.Label>
                        <Col md={6} xs={8}>
                          {item.number}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="value mb-1"
                        controlId="gender"
                      >
                        <Form.Label column lg={2} md={3} xs={4}>
                          Gender
                        </Form.Label>
                        <Col md={6} xs={8}>
                          Male
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="value mb-1"
                        controlId="dob"
                      >
                        <Form.Label column lg={2} md={3} xs={4}>
                          DOB
                        </Form.Label>
                        <Col md={6} xs={8}>
                          {item.dob}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="value mb-1"
                        controlId="residence"
                      >
                        <Form.Label column lg={2} md={3} xs={4}>
                          Residence
                        </Form.Label>
                        <Col md={6} xs={8}>
                          {item.address}
                        </Col>
                      </Form.Group>
                    </Form>
                  </Tab>
                  <Tab eventKey="back" title="Education Background">
                    <Form>
                      <span className="editing">
                        <BiPencil />
                      </span>
                      <Form.Group
                        as={Row}
                        className="value mb-1"
                        controlId="email"
                      >
                        <Form.Label column lg={2} md={3} xs={4}>
                          Stream
                        </Form.Label>
                        <Col md={6} xs={8}>
                          {item.stream}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="value mb-1"
                        controlId="name"
                      >
                        <Form.Label column lg={2} md={3} xs={4}>
                          Major
                        </Form.Label>
                        <Col md={6} xs={8}>
                          {item.major}
                        </Col>
                      </Form.Group>
                      
                      <Form.Group
                        as={Row}
                        className="value mb-1"
                        controlId="phone"
                      >
                        <Form.Label column lg={2} md={3} xs={4}>
                        College
                        </Form.Label>
                        <Col md={6} xs={8}>
                          {item.college}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="value mb-1"
                        controlId="gender"
                      >
                        <Form.Label column lg={2} md={3} xs={4}>
                          Gender
                        </Form.Label>
                        <Col md={6} xs={8}>
                          Male
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="value mb-1"
                        controlId="dob"
                      >
                        <Form.Label column lg={2} md={3} xs={4}>
                          DOB
                        </Form.Label>
                        <Col md={6} xs={8}>
                          {item.dob}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="value mb-1"
                        controlId="residence"
                      >
                        <Form.Label column lg={2} md={3} xs={4}>
                          Residence
                        </Form.Label>
                        <Col md={6} xs={8}>
                          {item.state}
                        </Col>
                      </Form.Group>
                    </Form>
                  </Tab>
                </Tabs>
              </div>

              <div className="col-lg-4 d-none d-md-block col-md-5 col-sm-12 col-xs-12">
                <div className="rigthside p-0 p-sm-5">
                  <Rightside />
                </div>
              </div>
            </div>
          </div>
        ))}
        <Footer />
        <FooterMob />
      </>
    )
  );
};

export default Profile;
